import axios from 'axios';

import { VUE_APP_API_URL } from '@/utilities/constants.js';

export const state = initialState();

export const actions = {
  getProfileInformation: async ({ commit }, payload) => {
    try {
      commit('mutateProfileInfoError', '');
      const { profileId, ...params } = payload;
      const res = await axios.get(`${VUE_APP_API_URL}/profiles/${profileId}`, {
        ...params
      });
      commit('mutateProfileInfo', res.data);
      return res;
    } catch (err) {
      commit('mutateProfileInfoError', 'Error fetching user');
      return err.response;
    }
  },

  updateProfileInformation: async (_, payload) => {
    const { profileId, ...newProfileInformation } = payload;

    try {
      const res = await axios.put(`${VUE_APP_API_URL}/profiles/${profileId}`, {
        profile: {
          ...newProfileInformation
        }
      });
      return res;
    } catch (err) {
      return err.response;
    }
  },

  getProfileProjects: async ({ commit, rootState }, payload) => {
    const { profileId, ...params } = payload;

    try {
      const res = await axios.get(
        `${VUE_APP_API_URL}/profiles/${profileId}/projects`,
        {
          params: { ...params }
        }
      );

      commit('mutateProfileProjects', res.data);
      //save for now need to check behaviour with new changes all env have main project 1.5.4
      // if (rootState.brand.brand.name.toLowerCase() !== 'trust') {
      //   const { list, ...theRest } = res.data;
      //   const withoutTrust = list.filter(item => {
      //     return !item.project.mainProject;
      //   });

      //   const newData = {
      //     ...theRest,
      //     list: withoutTrust
      //   };

      //   commit('mutateProfileProjects', newData);
      // } else commit('mutateProfileProjects', res.data);
      return res;
    } catch (err) {
      return err;
    }
  },

  getProjectViaUser: async ({ commit }, payload) => {
    try {
      const { profileId, projectId } = payload;
      const res = await axios.get(
        `${VUE_APP_API_URL}/profiles/${profileId}/projects`,
        {
          params: {
            projectId
          }
        }
      );

      commit('mutateProjectViaUser', res.data);
      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },

  getProfileDocuments: async ({ commit }, payload) => {
    const { profileId, ...params } = payload;

    try {
      const res = await axios.get(
        `${VUE_APP_API_URL}/profiles/${profileId}/documents`,
        {
          params: { ...params }
        }
      );
      commit('mutateProfileDocuments', res.data);
      return res;
    } catch (err) {
      return;
    }
  },

  getProfileTemplateForms: async ({ commit }, payload) => {
    const { profileId, ...params } = payload;
    try {
      const res = await axios.get(
        `${VUE_APP_API_URL}/profiles/${profileId}/template-forms`,
        { params: { ...params } }
      );
      commit('mutateProfileTemplateForms', res.data);
      return res;
    } catch (err) {
      return;
    }
  },

  getProfileFavoriteTemplates: async ({ commit }, payload) => {
    try {
      const { profileId, ...params } = payload;

      const res = await axios.get(
        `${VUE_APP_API_URL}/profiles/${profileId}/template-forms/favorites`,
        {
          params: { ...params }
        }
      );

      commit('mutateProfileTemplateFavorites', res.data);

      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },

  getProfileDocumentsForRevision: async ({ commit }, payload) => {
    try {
      commit('mutateProfileDocumentsForRevisionError', '');
      const { profileId, ...params } = payload;
      const res = await axios.get(
        `${VUE_APP_API_URL}/profiles/${profileId}/documents-to-revise`,
        {
          params
        }
      );
      commit('mutateProfileDocumentsForRevision', res.data);
      return res;
    } catch (error) {
      commit(
        'mutateProfileDocumentsForRevisionError',
        'Unable to fetch showcases at this time'
      );
      return error.response;
    }
  },

  getProfileDocumentRevisionCount: async ({ commit }, payload) => {
    try {
      const { profileId, ...params } = payload;
      const { data } = await axios.get(
        `${VUE_APP_API_URL}/profiles/${profileId}/count-documents-to-revise`,
        {
          params
        }
      );
      commit('mutateProfileDocsToReviseCount', data);
    } catch {
      commit(
        'mutateProfileErrorDocsToReviseCount',
        'There was an error fetching all document counts'
      );
    }
  },

  getAllProfiles: async ({ commit }, payload) => {
    try {
      const res = await axios.get(`${VUE_APP_API_URL}/profiles`, {
        params: { ...payload }
      });

      commit('mutateAllProfiles', res.data);
      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },

  getProfileProjectGroups: async ({ commit }, payload) => {
    try {
      const { profileId, ...params } = payload;
      const res = await axios.get(
        `${VUE_APP_API_URL}/profiles/${profileId}/project-groups`,
        { params }
      );
      commit('mutateProfileProjectGroups', res.data);
      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },

  getProfileProjectsAssociatedWithTemplate: async ({ commit }, payload) => {
    try {
      const { profileId, templateFormId } = payload;

      const res = await axios.get(
        `${VUE_APP_API_URL}/profiles/${profileId}/template-forms/${templateFormId}/projects`
      );

      commit('mutateProjectsForTemplate', res.data);
      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },

  getProfileLinkedItineraries: async ({ commit }, payload) => {
    try {
      const { profileId, ...params } = payload;

      const res = await axios.get(
        `${VUE_APP_API_URL}/profiles/${profileId}/itineraries/linked`,
        {
          params: { ...params }
        }
      );

      commit('mutateProfileLinkedItineraries', res.data);

      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },

  getProfileCreatedItineraries: async ({ commit }, payload) => {
    try {
      const { profileId, ...params } = payload;

      const res = await axios.get(
        `${VUE_APP_API_URL}/profiles/${profileId}/itineraries/creator`,
        {
          params: { ...params }
        }
      );

      commit('mutateProfileCreatedItineraries', res.data);

      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },

  getProfileBookmarkedItineraries: async ({ commit }, payload) => {
    try {
      const { profileId, ...params } = payload;

      const res = await axios.get(
        `${VUE_APP_API_URL}/profiles/${profileId}/itineraries/bookmarks`,
        {
          params: { ...params }
        }
      );

      commit('mutateProfileBookmarkedItineraries', res.data);

      return res;
    } catch (error) {
      return error.response;
    }
  },

  getProfileImpersonatorStatus: async ({ commit }, payload) => {
    try {
      const { profileId } = payload;

      const res = await axios.get(
        `${VUE_APP_API_URL}/profiles/${profileId}/can-impersonate`
      );

      commit('mutateProfileImpersonatorStatus', res.data);

      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },

  getProfileImpersonations: async ({ commit }, payload) => {
    try {
      const { profileId, ...params } = payload;

      const res = await axios.get(
        `${VUE_APP_API_URL}/profiles/${profileId}/impersonated`,
        {
          params: { ...params }
        }
      );

      commit('mutateProfileImpersonations', res.data);

      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },

  getAllProfilesForDebounceSearch: async ({ commit }, payload) => {
    try {
      const res = await axios.get(`${VUE_APP_API_URL}/profiles`, {
        params: { ...payload }
      });

      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },

  getProfileProjectFilters: async ({ commit, rootState }, payload) => {
    const { profileId, ...params } = payload;

    try {
      const res = await axios.get(
        `${VUE_APP_API_URL}/profiles/${profileId}/projects`,
        {
          params: { ...params }
        }
      );
      commit('mutateProfileProjectsFilters', res.data);

      return res;
    } catch (err) {
      return err;
    }
  },

  resetProfileProjectFilters: ({ commit }) => {
    commit('resetProfileProjectFilters');
  },

  //called to check if user has the ability so submit itineraries to a project when
  //user's itinerary count has reached max
  getProjectsUserCanSubmitItineraries: async (
    { commit, rootState },
    payload
  ) => {
    const { profileId, ...params } = payload;

    try {
      const res = await axios.get(`${API_URL}/profiles/${profileId}/projects`, {
        params: { ...params }
      });

      return res;
    } catch (err) {
      return err;
    }
  }
};

export const mutations = {
  resetProfileProjectFilters: state => {
    state.profileProjectFilters = [];
  },

  mutateProfileInfo: (state, payload) => {
    state.profileInfo = payload;
  },
  mutateProfileProjects: (state, payload) => {
    state.profileProjects = payload;
  },

  mutateProfileProjectsFilters: (state, payload) => {
    const projectList = [{ text: 'View All Projects', value: '' }];
    const projects = payload.list.map(({ project }) => ({
      text: project.name,
      value: project.projectId.replace('#', '')
    }));

    projectList.push(...projects);

    state.profileProjectFilters = projectList;
  },

  mutateProjectViaUser: (state, payload) => {
    state.projectViaUser = payload;
  },

  mutateProfileDocuments: (state, payload) => {
    state.profileDocuments = payload;
  },

  mutateProfileTemplateForms: (state, payload) => {
    state.profileTemplateForms = payload;
  },

  mutateProfileTemplateFavorites: (state, payload) => {
    state.profileTemplateFavorites = payload;
  },

  mutateProfileDocumentsForRevision: (state, payload) => {
    state.profileDocumentsForRevision = payload;
  },

  mutateAllProfiles: (state, payload) => {
    state.allProfiles = payload;
  },

  mutateProfileProjectGroups: (state, payload) => {
    state.profileProjectGroups = payload;
  },

  mutateProjectsForTemplate: (state, payload) => {
    state.projectsForTemplate = payload;
  },

  mutateProfileLinkedItineraries: (state, payload) => {
    state.profileLinkedItineraries = payload;
  },

  mutateProfileCreatedItineraries: (state, payload) => {
    state.profileCreatedItineraries = payload;
  },

  mutateProfileBookmarkedItineraries: (state, payload) => {
    state.profileBookmarkedItineraries = payload;
  },

  mutateProfileImpersonatorStatus: (state, payload) => {
    state.profileImpersonatorStatus = payload;
  },

  mutateProfileImpersonations: (state, payload) => {
    state.profileImpersonations = payload;
  },

  mutateProfileDocumentsForRevisionError: (state, payload) => {
    state.profileDocumentsForRevisionError = payload;
  },

  mutateProfileDocsToReviseCount(state, payload) {
    state.profileDocsToReviseCount = payload;
  },

  mutateProfileErrorDocsToReviseCount(state, payload) {
    state.profileErrorDocsToReviseCount = payload;
  },

  mutateProfileInfoError(state, payload) {
    state.profileInfoError = payload;
  }
};

export const getters = {};

function initialState() {
  return {
    profileInfo: {},
    profileInfoError: '',

    profileProjects: { list: [] },
    projectViaUser: {},
    profileDocuments: [],
    profileTemplateForms: { list: [] },
    profileTemplateFavorites: [],
    allProfiles: {
      list: []
    },
    profileProjectGroups: { list: [] },
    projectsForTemplate: [],
    profileLinkedItineraries: {},
    profileCreatedItineraries: {},
    profileBookmarkedItineraries: {},
    profileImpersonatorStatus: null,
    profileImpersonations: {},
    profileProjectFilters: [],

    // Revisions
    profileDocsToReviseCount: [],
    profileDocumentsForRevision: { list: [] },
    profileDocumentsForRevisionError: '',
    profileErrorDocsToReviseCount: ''
  };
}
